import { Component, Input, EventEmitter, Output } from '@angular/core';
import { NgwService } from '../../app/ngw.service';
import { NgwGame, NgwTeam, NgwPlayer, NgwRound, NgwPick, NgwScore } from '../../app/classes/NgwGame';

@Component({
    selector: "past-game",
    template: `
        <ion-item>
        <div style="float: left;">
         <button ion-button clear large (click)="starGame(game)"  item-left style="float: left" *ngIf="!game.starred">
                <ion-icon name="star-outline" style="color: black;"></ion-icon>
             </button>
             <button ion-button clear large (click)="starGame(game)"  item-left style="float: left" *ngIf="game.starred">
                <ion-icon name="star" style="color: goldenrod   ;"></ion-icon>
             </button>

            <div  [ngClass]="'logo logo-bg-dark--team-' + game.nhlGame.teams.away.team.abbreviation.toLowerCase()"></div> <div class="logoAt"> @ </div> <div  [ngClass]="'logo logo-bg-dark--team-' + game.nhlGame.teams.home.team.abbreviation.toLowerCase()"></div>
             
       </div>
       <div style="float: right; text-align: right; vertical-align: top;">


             <button ion-button (click)="loadGame(game)"  item-right>Load Game</button>
             <div item-right><p>{{game.gameDate | amDateFormat: 'M/D/YY'}}</p></div>
        </div>
        <div style="float: left;">
        <div>
                <strong>{{game.rounds.length}} Rounds</strong><br/>
                <p *ngFor="let player of game.players">
                    {{player.name}} {{player.balance}}
                </p>
             </div>
        </div>

        </ion-item>
        `,
         styles: [
     '.logo { width: 80px; height: 80px; background-repeat: no-repeat; background-position: 50% 50%; float: left; }',
     '.logoAt {width: 20px; height: 80px; float: left; line-height: 80px }'
     ]
})

export class PastGame {
    @Input() game:NgwGame
     @Output() reloadGameClicked: EventEmitter<any> = new EventEmitter();
     

    constructor( public ngwService: NgwService){
        
    }

    starGame(game:NgwGame) {
        game.starred = !game.starred;
        this.ngwService.saveGames();
    }

    loadGame(game:NgwGame) {
        this.ngwService.currentGame = game;
        this.reloadGameClicked.emit();
    }

}


// WEBPACK FOOTER //
// ./src/pages/pastGames/pastGame.ts